/**
 * Created by Sale on 6/4/2024
 */
import {Role} from "@/utils/utils";
import assessmentPage from "@/modules/assessment-module/views/assessment/assessment-page.vue";
import dataPackagingPage from "@/modules/data-packaging-module/views/data-packaging/data-packaging-page.vue";

const Module = () => import("./Module.vue");


//TODO change permission uac:get
const moduleRoute = {
    path: "/data-packaging-module",
    component: Module,
    children: [
        {
            path: '/',
            name: 'data-packaging-module',
            meta: {
                product: 'Realite Admin',
                title: 'Data Packaging',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-packaging:get-packaging-report',
                topBarTitle: '',
                menuPriority: 8,
                hasMenu: true,
                hasInternalTransition: false
            },
            component: dataPackagingPage
        }
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
